export enum IntegrationTypes {
  JIRA = 'Jira',
}
